<template>
    <div class="addButton" v-if="showPharmaceuticalCareButton">
        <lk-button type="primary" style="margin-right: 30px" @click="toUrl('drugInformation')">药品信息查询</lk-button>
        <lk-button type="primary" @click="toUrl('drugInteraction')">药品相互作用</lk-button>
    </div>
</template>
<script>
export default {
  name: 'PharmaceuticalCareButton',
  props: {
    showPharmaceuticalCareButton: {// 是否展示药学服务按钮
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toUrl(url) {
      const urlObj = {
        drugInformation: 'https://drugs.medlive.cn/drugref/index.do', // 药品信息查询
        drugInteraction: 'https://drugs.medlive.cn/drugref/drugCheckIndex.do', // 药品相互作用
      };
      window.open(urlObj[url]);
    },
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="less" scoped>
    .addButton{
      position: absolute;
      right: 20px;
      top: 10px;
      z-index: 1;
    }
</style>
